<template>
    <div id="app">
        <!-- <Header v-if="boxshow"></Header> -->
        <router-view></router-view>
        <!-- <Bottom v-if="boxshowb"></Bottom> -->
    </div>
</template>

<script>
    import Header from './pages/header.vue'
    import Bottom from './pages/bottom.vue'
    export default
    {
        name: 'App',
        components:
        {
            Header,
            Bottom
        },
        data()
        {
            return {
                boxshow: true,
                boxshowb: true
            }
        },
        // 监听,当路由发生变化的时候执行
        watch:
        {
            $route( to, from )
            {
                // 当路由发生改变时刷新页面
                // location.reload()
            }
        },
        methods:
        {

        },
        mounted()
        {
            console.log( this.$route.path )
            // 通过路由判断是否为首页从而是否复用组件
            if ( this.$route.path === '' )
            {
                this.boxshow = false
                this.boxshowb = false
            }
            else if ( this.$route.path === '/logi' || this.$route.path === '/regis' )
            {
                this.boxshow = false
            }
        }
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    ul li {
        list-style: none;
    }

    a {
        text-decoration: none;
    }

    body {
        width: 100%;
        min-width: 75rem;
        margin: auto;
    }
    .el-select .el-input.is-focus .el-input__inner {border-color: #11D165}
    .el-select .el-input__inner:focus {border-color: #11D165}
    .el-select-dropdown__item.selected {color: #11D165;font-weight: 700}
    .el-input.is-active .el-input__inner, .el-input__inner:focus {border-color: #11D165;outline: 0}
    .el-date-table td.today span {color: #11D165;font-weight: 700}
    .el-date-table td.current:not(.disabled) span {color: #FFF;background-color: #11D165}
    .el-time-panel__btn.confirm {font-weight: 800;color: #11D165}
    .el-switch.is-checked .el-switch__core {border-color: #11D165;background-color: #11D165}
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {background-color: #11D165;border-color: #11D165}
    .el-checkbox__input.is-checked+.el-checkbox__label {color: #11D165}
    .el-checkbox__inner:hover {border-color: #11D165}
    .el-checkbox__input.is-focus .el-checkbox__inner{border-color:#11D165;}
    .el-radio__input.is-checked .el-radio__inner {border-color: #11D165;background: #11D165}
    .el-radio__input.is-checked+.el-radio__label {color: #11D165}
    .el-radio__inner:hover {border-color: #11D165}
    .el-textarea__inner:focus {outline: 0;border-color: #11D165}
    .el-pagination__sizes .el-input .el-input__inner:hover {border-color: #11D165}
    .el-pager li.active {color: #11D165;cursor: default}
    .el-pager li:hover {color: #11D165}
    .el-pagination button:hover {color: #11D165}
    .el-date-table td.available:hover {color: #11D165}
    .el-tabs__item:hover {color: #11D165;cursor: pointer}
    .el-tabs__item.is-active {color: #11D165}
    .el-tabs__active-bar {background-color: #11D165}
    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {background-color: #ecf5ff;color: #11D165}
    .el-button--text {color: #11D165}
    .el-tabs--card>.el-tabs__header {border-bottom: 1px solid #ffffff}
    .el-button:active {color: #11D165;border-color: #11D165;outline: 0}
    .el-button.is-active, .el-button.is-plain:active {color: #11D165;border-color: #11D165;background-color: #ecf5ff;}
    .el-button.is-plain:focus, .el-button.is-plain:hover {background: #ecf5ff;border-color: #11D165;color: #11D165}
    .el-button:focus, .el-button:hover {color: #11D165;border-color: #11D165;background-color: #ecf5ff}
    .el-button--primary {color: #FFF;background-color: #11D165;border-color: #11D165}
    .el-button--primary.is-active, .el-button--primary:active {background: #11D165;border-color: #11D165;color: #FFF}
    .el-button--primary:focus, .el-button--primary:hover {background: #11D165;border-color: #11D165;color: #FFF}
    .el-button--primary.is-plain {color: #11D165;background: #ecf5ff;border-color: #11D165}
    .el-button--success {color: #FFF;background-color: #11D165;border-color: #11D165}
    .el-button--success.is-active, .el-button--success:active {background: #11D165;border-color: #11D165;color: #FFF}
    .el-button--success:focus, .el-button--success:hover {background: #11D165;border-color: #11D165;color: #FFF}
    .el-button--success.is-plain {color: #11D165;background: #ecf5ff;border-color: #11D165}
    .el-button--info {color: #FFF;background-color: #909399;border-color: #909399}
    .el-button--info.is-active, .el-button--info:active {background: #909399;border-color: #909399;color: #FFF}
    .el-button--info:focus, .el-button--info:hover {background: #909399;border-color: #909399;color: #FFF}
    .el-button--info.is-plain {color: #909399;background: #ecf5ff;border-color: #909399}
    .el-button--warning {color: #FFF;background-color: #E6A23C;border-color: #E6A23C}
    .el-button--warning.is-active, .el-button--warning:active {background: #E6A23C;border-color: #E6A23C;color: #FFF}
    .el-button--warning:focus, .el-button--warning:hover {background: #E6A23C;border-color: #E6A23C;color: #FFF}
    .el-button--warning.is-plain {color: #E6A23C;background: #ecf5ff;border-color: #E6A23C}
    .el-button--danger {color: #FFF;background-color: #F56C6C;border-color: #F56C6C}
    .el-button--danger.is-active, .el-button--danger:active {background: #F56C6C;border-color: #F56C6C;color: #FFF}
    .el-button--danger:focus, .el-button--danger:hover {background: #F56C6C;border-color: #F56C6C;color: #FFF}
    .el-button--danger.is-plain {color: #F56C6C;background: #ecf5ff;border-color: #F56C6C}
    .test-1::-webkit-scrollbar {
        width: 6px;
        height: 0px
    }

    .test-1::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #11D165
    }


    /*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/

    .test-1::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #f5f5f5
    }
    .good-size-p {
        color:#C30000;
        font-size: 12px;
    }
    .good-size-p2 {
        color:#A2ADA6;
        font-size: 15px;
        margin:5px 0 12px 0
    }
    .marketlistbut2{
        transition-duration: 0.4s;
    }

    .marketlistbut2:hover {
		-webkit-box-shadow: #ccc 200px 20px 20px;
		-moz-box-shadow: #ccc 10px 10px 10px;
		box-shadow: #ccc 10px 10px 10px;
		-webkit-transform: translate(0px, -5px);
		-moz-transform: translate(5px, 5px);
		background-color: #FFFFFF;
		cursor: pointer;
	}
    .ellipsis-nowrap{overflow: hidden;width:40%;white-space: nowrap;text-overflow: ellipsis;}
    .all-com-p{font-size: 12px;color:#A2ADA6;margin:auto 0}
    .home-img-box{width:180px;height: 180px;}

    /**首页黑白色 */
    /* img {
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;
    }
    .cont_img{
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;
    }
    .cont_imgs{
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;
    }
    .index_botimgaD{
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;
    }
    .index_botimga{
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;
    }
    .index_botimgaB{
        transition: all .3s ease;
        filter:grayscale(100%);
        opacity: 1;}
    .discont_header .h-left .info{
        background-color:#000000 !important
    }
    .header_inputs{background-color: #000000 !important;}
    .input-box-inputbox{border: 2px solid #000000 !important}
    p{color:#000000 !important}
    .hea-xian{background: #929292 !important;}
    .header_lis{background: #000000 !important;}
    .discont_item .discont_box .sales_price{color: #000000 !important}
    .cont_centopAlis span{color:#000000 !important}
    .hun_jsmotA_centlin {
    border-bottom: 5px solid #000000 !important;}
    .letbot_boxliback{background-color: #000000 !important;}
    .hun_jsmotBtoplin {
    border-bottom: 5px solid #000000 !important;}
    .header-reg-but{background-color: #929292 !important;} */

</style>